import React from 'react'
import MaterialIndex from '../features/material'
const Material = () => {
  return (
    <MaterialIndex />
  )
}

export default Material